import routers from '../web-sh/src/config/routers';
import keys from './keys';
import constants from './constants';

export default {
  ...routers,
  AUTH_ROUTERS: [
    {
      name: keys.AUTHENTICATE,
      path: '/authenticate',
      element: 'Authenticate',
      not_auth: true
    },
    {
      name: keys.AUTHENTICATE_APP,
      path: '/authenticate-app',
      element: 'AuthenticateApp',
      not_auth: true
    },
    {
      name: keys.LOGIN,
      path: '/login',
      element: 'Login',
      not_auth: true
    },
    {
      name: keys.REGISTER,
      path: '/register',
      element: 'Register',
      not_auth: true
    },
    {
      name: keys.LOCK,
      path: '/lock',
      element: 'Lock',
    },
    {
      name: keys.CREATE_MASTER_PASSWORD,
      path: '/create-master-password',
      element: 'CreateMasterPassword',
    },
    {
      name: keys.SETUP_2FA,
      path: '/setup-2fa',
      element: 'Setup2FA',
    },
    {
      name: keys.SETUP_PASSWORDLESS,
      path: '/setup-passwordless',
      element: 'SetupPasswordless',
    }
  ],
  ADMIN_ROUTERS: [
    ...routers.ADMIN_ROUTERS.map((r) => {
      if ([keys.POLICIES, keys.POLICIES_VIOLATED].includes(r.name)) {
        return {
          ...r,
          userTypes: [
            constants.USER_TYPE.ENTERPRISE
          ],
        }
      }
      return r
    }),
    {
      name: keys.PRIVATE_EMAIL,
      path: '/private-email',
      element: 'PrivateEmail',
    },
    {
      name: keys.SETTINGS_MEMBERS,
      path: '/settings/members',
      element: 'SettingsMembers',
      plans: [
        constants.PLANS.FAMILY,
        constants.PLANS.LIFETIME_FAMILY,
        constants.PLANS.LIFETIME_TEAM
      ]
    },
    {
      name: keys.SETTINGS_PLANS_BILLING,
      path: '/settings/plans-billing',
      element: 'SettingsPlansBilling',
      userTypes: [
        constants.USER_TYPE.PERSONAL
      ],
    },
    {
      name: keys.REWARDS,
      path: '/rewards',
      element: 'Rewards',
      plans: [
        constants.PLANS.FREE,
        constants.PLANS.PREMIUM,
        constants.PLANS.FAMILY
      ],
      userTypes: [
        constants.USER_TYPE.PERSONAL
      ],
    },
    {
      name: keys.MANAGE_PLANS,
      path: '/manage-plans',
      element: 'ManagePlans',
      label: 'manage_plans.title',
      plans: [
        constants.PLANS.FREE,
        constants.PLANS.PREMIUM,
        constants.PLANS.FAMILY
      ],
      userTypes: [
        constants.USER_TYPE.PERSONAL
      ],
    },
    {
      name: keys.WELCOME_TOUR,
      path: '/welcome-tour',
      element: 'WelcomeTour',
      label: 'welcome_tour.title'
    },
    {
      name: keys.CHECK_SCAM,
      path: '/check-scam',
      element: 'CheckScam',
      country: 'VN'
    },
    {
      name: keys.SCAM_MY_REPORT,
      path: '/check-scam/report',
      element: 'ScamMyReport',
      country: 'VN'
    },
    {
      name: keys.SCAM_SETTING,
      path: '/check-scam/setting',
      element: 'ScamSetting',
      country: 'VN'
    }
  ]
};
